import { ConfigStateService, LanguageInfo, SessionStateService } from '@abp/ng.core';
import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import snq from 'snq';

@Component({
    selector: 'ca-languages',
    templateUrl: './languages.component.html',
    styleUrls: ['./languages.component.scss'],
    standalone: false
})
export class LanguagesComponent {
  private readonly pinnedLanguageOrder = ['en', 'en-US', 'tr', 'tr-TR'];

  get smallScreen(): boolean {
    return window.innerWidth < 992;
  }

  languages$: Observable<LanguageInfo[]> = this.configState.getDeep$('localization.languages');

  get defaultLanguage$(): Observable<string> {
    return this.languages$.pipe(
      map(
        languages =>
          snq(
            () => languages.find(lang => lang.cultureName === this.selectedLangCulture).displayName
          ),
        ''
      )
    );
  }

  get dropdownLanguages$(): Observable<LanguageInfo[]> {
    return this.languages$.pipe(
      map(
        languages =>
          snq(
            () =>
              this.sortLanguages(
                languages.filter(lang => lang.cultureName !== this.selectedLangCulture)
              ),
            []
          ),
        []
      )
    );
  }

  get selectedLangCulture(): string {
    return this.sessionState.getLanguage();
  }

  constructor(private sessionState: SessionStateService, private configState: ConfigStateService) {}

  private sortLanguages<T extends { cultureName?: string; displayName?: string }>(languages: T[]): T[] {
    return [...languages].sort((left, right) => {
      const pinnedOrderDifference = this.getPinnedOrder(left.cultureName) - this.getPinnedOrder(right.cultureName);

      if (pinnedOrderDifference !== 0) {
        return pinnedOrderDifference;
      }

      return (left.displayName || '').localeCompare(right.displayName || '');
    });
  }

  private getPinnedOrder(cultureName?: string): number {
    const normalizedCultureName = (cultureName || '').toLowerCase();
    const index = this.pinnedLanguageOrder.findIndex(
      language => language.toLowerCase() === normalizedCultureName
    );

    return index === -1 ? Number.MAX_SAFE_INTEGER : index;
  }

  onChangeLang(cultureName: string) {
    // The culture cookie is issued by the API (HttpOnly) when the application configuration is
    // requested with the selected culture, see CultureQueryInterceptor; nothing is written from here.
    this.sessionState.setLanguage(cultureName);
    window.location.reload();
  }
}
